import { component$ } from "@builder.io/qwik";

export const ProfileSkeleton = component$(() => {
  return (
    <div class="animate-pulse [animation-duration:2s]">
      <div class="mx-auto my-4 flex max-w-5xl flex-col space-y-6 px-4 md:mt-8 md:space-y-8">
        {/* Hero Image */}

        {/* Profile Section */}
        <div class="mb-4 flex w-full flex-col gap-8 sm:flex-row">
          {/* Left Column */}
          <div class="flex-basis-0 flex-grow-2">
            {/* Profile Image */}
            <div class="relative">
              <div class="mx-auto aspect-square h-[200px] w-[200px] rounded-full bg-gray-400/20 ring-4 ring-white/10" />
            </div>
            {/* Brand Logo */}
            <div class="mt-4 flex items-center gap-2 px-4">
              <div class="h-12 w-12 rounded-full bg-gray-400/20" />
              <div class="h-6 w-24 rounded bg-gray-400/20" />
            </div>
          </div>

          {/* Right Column */}
          <div class="flex-basis-0 flex-grow-6 flex flex-col items-stretch justify-center gap-8">
            {/* Header */}
            <div class="flex flex-col items-center gap-4 sm:items-start md:flex-row">
              <div class="flex flex-col items-center gap-2 text-center sm:items-start sm:text-left">
                {/* Name and Badge */}
                <div class="flex items-center gap-2">
                  <div class="h-10 w-48 rounded-lg bg-gray-400/20" />
                  <div class="h-8 w-16 rounded-lg bg-gray-400/20" />
                </div>
                {/* Title */}
                <div class="mb-4 h-6 w-64 rounded bg-gray-400/20" />
                {/* Quote */}
                <div class="flex items-center gap-2">
                  <div class="h-5 w-full max-w-xl rounded bg-gray-400/20" />
                </div>
              </div>
              {/* CTA Button */}
              <div class="h-10 w-40 rounded-full bg-gray-400/20" />
            </div>

            {/* Navigation */}
            <nav class="flex gap-4 border-b border-gray-200/20 pb-2">
              <div class="h-8 w-20 rounded bg-gray-400/20" />
              <div class="h-8 w-24 rounded bg-gray-400/20" />
              <div class="h-8 w-20 rounded bg-gray-400/20" />
            </nav>
          </div>
        </div>

        {/* Content Grid */}
        <div class="flex w-full flex-col flex-col-reverse gap-8 md:flex-row">
          {/* Left Column - Coach Details */}
          <div class="flex-basis-0 flex-grow-2">
            <div class="space-y-4 rounded-lg border border-gray-200/20 bg-gray-400/5 p-4 backdrop-blur-sm">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} class="flex items-center gap-2">
                  <div class="h-6 w-6 rounded bg-gray-400/20" />
                  <div class="flex flex-col gap-1">
                    <div class="h-4 w-32 rounded bg-gray-400/20" />
                    <div class="h-3 w-24 rounded bg-gray-400/20" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Main Content */}
          <div class="flex-basis-0 flex-grow-6">
            <div class="space-y-8">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  class="rounded-lg border border-gray-200/20 bg-gray-400/5 p-6 backdrop-blur-sm"
                >
                  <div class="space-y-4">
                    <div class="h-8 w-48 rounded bg-gray-400/20" />
                    <div class="space-y-2">
                      <div class="h-4 w-full rounded bg-gray-400/20" />
                      <div class="h-4 w-5/6 rounded bg-gray-400/20" />
                      <div class="h-4 w-4/5 rounded bg-gray-400/20" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
